import React, { useState } from 'react';
import Checkbox from 'components/UI/Checkbox';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import styles from './UpdateExistingAppointments.module.scss';

export interface UpdateExistingAppointmentsProps {
    isLoading?: boolean;
    onClose: () => void;
    onKeepCurrentPrice: () => void;
    onApplyNewPrice: () => void;
}

const UpdateExistingAppointments: React.FC<UpdateExistingAppointmentsProps> = ({
    isLoading = false,
    onClose,
    onKeepCurrentPrice,
    onApplyNewPrice
}) => {
    const [acknowledged, setAcknowledged] = useState(false);

    return (
        <GenericModal
            onClose={onClose}
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Keep Current Price"
                            onClick={onKeepCurrentPrice}
                            variant="black"
                            disabled={isLoading}
                        />
                    </div>
                    <div className={styles.left}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Apply New Price"
                            onClick={onApplyNewPrice}
                            variant="green"
                            isLoading={isLoading}
                            disabled={!acknowledged || isLoading}
                        />
                    </div>
                </div>
            }
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Update Existing Appointments?</span>
                <span className={styles.description}>
                    You&apos;ve changed the base price of this service. Would you like to apply the new price to all
                    upcoming appointments that are not completed?
                </span>
                <div className={styles.checkboxContainer}>
                    <Checkbox
                        checked={acknowledged}
                        onChange={setAcknowledged}
                        className={styles.checkbox}
                    />
                    <span className={styles.checkboxLabel}>I understand this updates all upcoming appointments.</span>
                </div>
            </div>
        </GenericModal>
    );
};

export default UpdateExistingAppointments;
